import {type FilterProvider, FilterProviderType, FilterQueryParser} from '@github-ui/filter-core'
import {MoonIcon} from '@primer/octicons-react'

import type {QuerySegment} from './types'
import {dropWrappingQuotes} from './validate-query'

const keyPattern = new RegExp(/([\w.#-]+):/g)
export function tokenizeQuery(query: string, providers?: FilterProvider[]): QuerySegment[] {
  if (query.length > 1000) {
    // If the query is too long, avoid parsing to prevent a DoS attack. - rule `js/polynomial-redos`
    return [
      {
        type: 'text',
        value: query,
      },
    ]
  }

  if (!providers) {
    // Identify potential keys to create providers needed for parsing
    const keys = Array.from(query.matchAll(keyPattern), match => match[1] || '').filter(Boolean)
    providers = keys.map(buildFakeProvider)
  }

  const parser = new FilterQueryParser(providers)

  return parser
    .parse(query)
    .blocks.filter(block => block.type !== 'space')
    .map<QuerySegment>(block => {
      if (block.type === 'filter') {
        const isNegated = block.key.value.startsWith('-')
        const key = isNegated ? block.key.value.slice(1) : block.key.value
        const sanitizeValues = block.value.values.map(({value}) => {
          return typeof value === 'string' ? dropWrappingQuotes(value) : `${value}`
        })

        return {
          type: 'filter',
          key,
          isNegated,
          values: sanitizeValues,
          quotedValues: block.value.values.map(({value}) => `${value}`),
          raw: block.raw,
        }
      } else {
        return {type: 'text', value: block.raw}
      }
    })
}

function buildFakeProvider(key: string): FilterProvider {
  return {
    key,
    icon: MoonIcon,
    priority: 0,
    getSuggestions: () => null,
    type: FilterProviderType.Text,
    validateFilterBlockValues: (_filterQuery, _block, values) => values,
    getValueRowProps: () => ({text: ''}),
    options: {
      priority: 0,
      filterTypes: {},
      support: {},
    },
  }
}
